import React, { useState } from "react";
import { FaSearch, FaBars } from "react-icons/fa";
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";

import img from "../../Assets/original/ARN_3202.JPG";
import img1 from "../../Assets/original/ARN_3208.JPG";
import logo from '../../Assets/VMD LOGO.png';
import ContactModal from "../UI/ContactModal";
import Footer from "../UI/Footer";

const projectsData = [
  {
    city: "Ambur",
    status: "New Launch",
    budget: "2.91",
    title: "RDS ENCLAVE",
    location: "Ambur",
    possession: "Jan 2030",
    sqft: "1200 - 2400 sqft",
    price: "INR 2.91 Cr",
    image: img,
  },
  {
    city: "Brahmapuram",
    status: "sold out",
    budget: "1.23",
    title: "Rajeshwari enclave",
    location: "Brahmapuram",
    possession: "Jan 2029",
    sqft: "1200 - 2400 sqft",
    price: "INR 1.23 Cr",
    image: img1,
  },
  {
    city: "Somalaburam",
    status: "New Launch",
    budget: "1.21",
    title: "RDS ENCLAVE",
    location: "Somalaburam",
    possession: "Mar 2030",
    sqft: "1200 - 2400 sqft",
    price: "INR 1.21 Cr",
    image: img,
  },
];

const OurProjects = () => {
  const [search, setSearch] = useState("");
  const [filters, setFilters] = useState({ city: "", status: "", budget: "" });
  const [menuOpen, setMenuOpen] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);

  const handleReset = () => {
    setFilters({ city: "", status: "", budget: "" });
    setSearch("");
  };

  const filteredProjects = projectsData.filter((project) => {
    const matchCity = filters.city ? project.city === filters.city : true;
    const matchStatus = filters.status ? project.status === filters.status : true;
    const matchBudget = filters.budget
      ? parseFloat(project.budget) <= parseFloat(filters.budget)
      : true;
    const matchSearch = project.title.toLowerCase().includes(search.toLowerCase());
    return matchCity && matchStatus && matchBudget && matchSearch;
  });

  return (
    <div className="">
      {/* Top Bar */}
       <header className="  border-b top-0 left-0 w-full py-4 flex justify-between items-center p-2 z-50 bg-white/60 ">
        <Link to="/">                          
           <img src={logo} alt="Logo" className="h-auto md:w-56 w-36 object-cover " />


        </Link>

        <div className="hidden sm:flex items-center gap-3">
          <Link to="/"><button className="text-black font-medium text-lg">Home</button></Link>
          <Link to="/about"><button className="text-black font-medium text-lg">About Us</button></Link>
          <Link to="/projects"><button className="text-black font-medium text-lg">Our Projects</button></Link>
          <button
            onClick={() => setShowContactModal(true)}
            className="text-black font-medium text-lg   px-4 py-1   hover:bg-black hover:text-white"
          >
            Contact Us
          </button>
        </div>

        {/* Mobile Menu Button */}
        <div className="sm:hidden">
          <FaBars
            className="text-2xl cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
          />
        </div>
      </header>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="absolute top-20 right-4 bg-white text-black shadow-md rounded-lg py-2 w-48 z-50 sm:hidden">
          <Link to="/about" className="block px-4 py-2 hover:bg-gray-100" onClick={() => setMenuOpen(false)}>About Us</Link>
          <Link to="/projects" className="block px-4 py-2 hover:bg-gray-100" onClick={() => setMenuOpen(false)}>Our Projects</Link>
          <button className="block w-full text-left px-4 py-2 hover:bg-gray-100" onClick={() => {
            setShowContactModal(true);
            setMenuOpen(false);
          }}>
            Contact Us
          </button>
        </div>
      )}

      {/* Contact Modal */}
      <ContactModal isOpen={showContactModal} onClose={() => setShowContactModal(false)} />

      {/* Page Content */}
      <div className="px-4 sm:px-8 md:px-16 py-6">
        <nav className="text-sm text-gray-500 mb-6">Home &gt; Project</nav>
        <h2 className="text-2xl font-semibold mb-4">Find Where You Belong</h2>

        {/* Search Input */}
        <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden mb-6 shadow-sm">
          <div className="px-4 text-gray-500"><FaSearch /></div>
          <input
            type="text"
            placeholder="Enter Project Name"
            className="w-full px-3 py-2 outline-none text-sm"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        {/* Filters */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4 mb-6 border border-gray-200 rounded-lg p-4 shadow-sm">
          <select
            className="border border-gray-300 rounded px-3 py-2 text-sm"
            value={filters.city}
            onChange={(e) => setFilters({ ...filters, city: e.target.value })}
          >
            <option value="">Select City</option>
            {[...new Set(projectsData.map(p => p.city))].map(city => (
              <option key={city} value={city}>{city}</option>
            ))}
          </select>

          <select
            className="border border-gray-300 rounded px-3 py-2 text-sm"
            value={filters.status}
            onChange={(e) => setFilters({ ...filters, status: e.target.value })}
          >
            <option value="">Select Status</option>
            <option value="New Launch">New Launch</option>
            <option value="sold out">Sold Out</option>
          </select>

          <select
            className="border border-gray-300 rounded px-3 py-2 text-sm"
            value={filters.budget}
            onChange={(e) => setFilters({ ...filters, budget: e.target.value })}
          >
            <option value="">Select Budget</option>
            <option value="1.0">Below 1 Cr</option>
            <option value="1.5">Below 1.5 Cr</option>
            <option value="2.5">Below 2.5 Cr</option>
            <option value="3">Below 3 Cr</option>
          </select>

          <div className="col-span-1 sm:col-span-2 md:col-span-2 flex justify-end">
            <button
              onClick={handleReset}
              className="bg-[#ec2128] text-white text-sm px-4 py-2 rounded  "
            >
              Reset Filters
            </button>
          </div>
        </div>

        {/* Project Cards */}
   <div className="grid md:grid-cols-3 gap-6">
  {filteredProjects.map((project, index) => (
    <div
      key={index}
      className="rounded-xl overflow-hidden border shadow-md hover:shadow-xl transition duration-300 bg-white"
    >
      <div className="relative h-60">
        <img
          src={project.image}
          alt={project.title}
          className="w-full h-full object-cover"
        /> 
        <span className="absolute top-2 left-2 bg-blue-600 text-white text-xs font-semibold px-3 py-1 rounded-full shadow">
          {project.status}
        </span>
      </div>

      <div className="p-4 grid grid-cols-2 gap-2 text-sm text-gray-700">
        <h3 className="col-span-2 text-lg font-semibold text-gray-800">{project.title}</h3>
        <p className="text-gray-500">{project.location}</p>
        <p className="font-medium">{project.price} onwards</p>
        <p className="col-span-2 text-gray-600">Possession: {project.possession}</p>
        <p className="col-span-2 text-gray-600">{project.sqft}</p>

        <div className="col-span-2 pt-3">
          <button className="w-full text-sm font-medium text-white  bg-[#ec2128]  px-4 py-2 rounded-md transition">
            Download Brochure
          </button>
        </div>
      </div>
    </div>
  ))}
</div>

      </div> 

      <Footer/>
    </div>
  );
};

export default OurProjects;
